var WarmupQuestions = require("lib/academic/WarmupQuestions");

class TopicQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[TopicQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [BOOK_TYPE_STAGE];
		}

		var textVariety = answers[TEXT_VARIETY];
		if (!textVariety || !answers[TEXT_TYPE]) {
			return [BOOK_TYPE_STAGE];
		}

		if (textVariety.includes("non-fiction")) {
			var isComplete = answers[MAIN_ENTITY] && answers[MAIN_TOPICS] && (this.props.level != "3" || answers[GENRE]);
			return [NON_FICTION_GENRE_STAGE, isComplete];

		} else if (textVariety.includes("fiction")) {
			var stage = FICTION_GENRE_STAGE;

		} else {
			var stage = OTHER_GENRE_STAGE;

		}

		return [stage, answers.genre != undefined];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var bookTypeStageDisplay = (
			<div>
				{ this.props.getTextF("label1", BOOK_TYPE_STAGE) }
				{ this.props.renderDropdownF("choices1", BOOK_TYPE_STAGE, TEXT_TYPE, [TEXT_TYPE, TEXT_VARIETY]) }
				{ this.props.getTextF("label2", BOOK_TYPE_STAGE) }
				{ this.props.renderDropdownF("choices2", BOOK_TYPE_STAGE, TEXT_VARIETY, [TEXT_TYPE, TEXT_VARIETY]) }.
			</div>
		);

		if (stage != BOOK_TYPE_STAGE) {
			if (stage == FICTION_GENRE_STAGE || stage == OTHER_GENRE_STAGE) {
				var genreStageDisplay = (
					<div>
						{ this.props.getTextF("label1", stage) }
						{ this.props.renderDropdownF("choices1", stage, GENRE) }.
					</div>
				);
			} else if (stage == NON_FICTION_GENRE_STAGE) {
				if (this.props.level == "3") {
					var genreStageDisplay = (
						<div>
							{ this.props.getTextF("label1", stage) }
							{ this.props.renderDropdownF("choices1", stage, GENRE) }{ ". " }
							<br />
							{ this.props.getTextF("label2", stage) }
							{ this.props.renderDropdownF("choices2", stage, MAIN_ENTITY) }{ ". " }
							<br />
							{ this.props.getTextF("label3", stage) }
							{ this.props.renderMultiSelectF("choices3", stage, MAIN_TOPICS, 3) }.
						</div>
					);
				} else {
					if (this.props.level == "2") {
						var mainTopicsDisplay = (
							this.props.renderMultiSelectF("choices2", stage, MAIN_TOPICS, 3)
						);
					} else {
						var mainTopicsDisplay = (
							this.props.renderDropdownF("choices2", stage, MAIN_TOPICS)
						);
					}
					var genreStageDisplay = (
						<div>
							{ this.props.getTextF("label1", stage) }
							{ this.props.renderDropdownF("choices1", stage, MAIN_ENTITY) }{ ". " }
							<br />
							{ this.props.getTextF("label2", stage) }
							{ mainTopicsDisplay }.
						</div>
					);
				}
			}
		}

		return (
			<div>
				{ bookTypeStageDisplay }
				{ genreStageDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

TopicQuestion.STEM = "topic";

// stages
var BOOK_TYPE_STAGE = "booktype";
var FICTION_GENRE_STAGE = "fgenre";
var NON_FICTION_GENRE_STAGE = "nfgenre";
var OTHER_GENRE_STAGE = "othergenre";

var STAGES = [
	BOOK_TYPE_STAGE, FICTION_GENRE_STAGE, NON_FICTION_GENRE_STAGE, OTHER_GENRE_STAGE
];

// answer keys
var TEXT_TYPE = "text_type";
var TEXT_VARIETY = "text_variety";
var GENRE = "genre";
var MAIN_ENTITY = "main_entity";
var MAIN_TOPICS = "main_topics";

// referenced outside of component
TopicQuestion.TEXT_TYPE = TEXT_TYPE;
TopicQuestion.TEXT_VARIETY = TEXT_VARIETY;
TopicQuestion.MAIN_ENTITY = MAIN_ENTITY;
TopicQuestion.MAIN_TOPICS = MAIN_TOPICS;

TopicQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = TopicQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/TopicQuestion.js